import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Typography, Box, Select, MenuItem } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const LoginButton = () => {
  const { loginWithRedirect, isAuthenticated, logout, user } = useAuth0();

  if (isAuthenticated) {
    return (
      <Box>
        <Select
          value="User"
          displayEmpty
          renderValue={() => <AccountCircleIcon />}
          onChange={(event) => {
            if (event.target.value === 'logout') {
              logout({
                  logoutParams:{
                    returnTo: window.location.origin
                  }
                });
            }
          }}
        >
          <MenuItem disabled>
            <Typography variant="body1">
              {user.name}
            </Typography>
          </MenuItem>
          <MenuItem value="logout">
            Log Out
          </MenuItem>
        </Select>
      </Box>
    );
  }

  return (
    <Button 
      variant="contained" 
      color="secondary" 
      onClick={() => loginWithRedirect()}
    >
      Log In
    </Button>
  );
};

export default LoginButton; 